module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Light-b141e33ee7afe8a37ce4932b2e1b41c9.woff";